<template>
  <div>
    <div class="process-list">
      <div class="item">
        <div class="title">准备并上传资料</div>
        <div class="content">准备资料好后拍照上传</div>
      </div>
      <div class="item">
        <div class="title">下单支付</div>
        <div class="content">选择支付宝/微信支付费用</div>
      </div>
      <div class="item">
        <div class="title">寄送资料</div>
        <div class="content">按邮寄资料资料清单寄送资料</div>
      </div>
      <div class="item">
        <div class="title">资料审核并送签</div>
        <div class="content">签证专员预审资料、审核通过后第一时间安排送管</div>
      </div>
      <div class="item">
        <div class="title">出签并配送</div>
        <div class="content">出现后核对签证页信息，并按您所选的地址配送</div>
      </div>
    </div>
    <div class="img">
      <div class="txt">签证图例</div>
      <img
        src="https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/visa/%E5%85%A5%E5%8F%B0%E8%AF%81.jpg"
        alt="visa-page"
      />
    </div>
  </div>
</template>

<script>
import utils from '../services/tools.js';

export default {
  name: 'process',
  created() {
    utils.setTitle('办理流程');
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  line-height: 1;
}
body {
  font-size: 0;
  padding-bottom: 30px;
  counter-reset: order;
  font-family: Segoe UI, Lucida Grande, Helvetica, Arial, Microsoft YaHei,
    FreeSans, Arimo, Droid Sans, wenquanyi micro hei, Hiragino Sans GB,
    Hiragino Sans GB W3, FontAwesome, sans-serif;
}
h2 {
  font-size: 15px;
  font-weight: bold;
  margin: 20px auto;
  text-align: center;
  color: #6f6f6f;
}
.process-list {
  padding-top: 5px;
}
.item {
  padding-left: 37px;
  position: relative;
}
.item:first-of-type {
  margin-top: 5px;
}
.title {
  font-size: 15px;
  color: #444444;
}
.content {
  font-size: 14px;
  color: #777777;
  line-height: 1.2;
  padding: 13px 0;
  position: relative;
  padding-right: 10px;
}
.item::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 18px;
  border-left: 1px dotted #ff8585;
  z-index: 100;
}
.item:last-of-type::before {
  display: none;
}
.title::before {
  content: '';
  position: absolute;
  top: -2px;
  bottom: 0;
  left: 10px;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  background-color: #ff8585;
  z-index: 200;
}
.title::after {
  counter-increment: order;
  content: counter(order);
  position: absolute;
  top: -1px;
  bottom: 0;
  left: 10px;
  width: 16px;
  height: 17px;
  line-height: 17px;
  text-align: center;
  color: white;
  z-index: 300;
  font-size: 14px;
}
.img .txt {
  margin-top: 20px;
  padding: 0 12px;
  font-size: 15px;
  text-align: center;
  color: #333;
  font-weight: bold;
}
.img img {
  width: 80%;
  display: block;
  margin: 15px auto 0 auto;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}
</style>
